import { createTheme } from "@mui/material/styles";
import { wscType } from "./wscTheme.types";

export const SPACING = [
  "0.286rem",
  "0.571rem",
  "1.143rem",
  "1.714rem",
  "2.286rem",
  "2.857rem",
] as const;

export const wscTheme: wscType = {
  palette: {
    primary: {
      100: "#80B8FF",
      300: "#5AA3FF",
      500: "#3079D6",
      700: "#13244D",
      contrastText: "#F0F0F0",
    },
    neutral: {
      0: "#ffffff",
      100: "#F0F0F0",
      200: "#BABABA",
      300: "#8E8E8E",
      400: "#616161",
      500: "#404040",
      600: "#333333",
      700: "#282828",
      800: "#181818",
      900: "#010101",
    },
    success: {
      100: "#00E5A0",
      300: "#00B27C",
      500: "#007F58",
      700: "#006547",
    },
    warning: {
      100: "#FF5368",
      300: "#FF364E",
      500: "#AF001B",
      700: "#500009",
    },
    supporting: {
      brightGreen: "#96FE7C",
      pink: "#FF60C9",
      cyan: "#67FFF5",
      paleYellow: "#FDFF91",
      yellow: "#E5FF00",
      paleOrange: "#FFA461",
      lightPurple: "#C191FF",
    },
  },
  typography: {
    header: {
      fontWeight: "700",
      fontSize: "2rem",
    },
    header2: {
      fontWeight: "700",
      fontSize: "1.714rem",
    },
    header3: {
      fontWeight: "bold",
      fontSize: "1.429rem",
    },
    header4: {
      fontWeight: "700",
      fontSize: "1.286rem",
    },
    header5: {
      fontWeight: "600",
      fontSize: "1.143rem",
      lineHeight: "140%",
    },
    body1: {
      fontWeight: "400",
      fontSize: "1rem",
      lineHeight: "120%",
    },
    body1bold: {
      fontWeight: "700",
      fontSize: "1rem",
      lineHeight: "120%",
    },
    body2: {
      fontWeight: "400",
      fontSize: "0.857rem",
    },
    body2bold: {
      fontWeight: "700",
      fontSize: "0.857rem",
    },
    body3: {
      fontWeight: "400",
      fontSize: "0.714rem",
    },
    body4: {
      fontWeight: "400",
      fontSize: "0.571rem",
    },
    body4bold: {
      fontWeight: "700",
      fontSize: "0.571rem",
    },
    label: {
      fontWeight: "700",
      fontSize: "0.714rem",
    },
    button: {
      fontSize: "1rem",
      fontWeight: "bold",
    },
  },
  spacing: [...SPACING],
  radius: {
    none: "0px",
    s: "0.143rem",
    sm: "0.286rem",
    m: "0.571rem",
    l: "1.143rem",
    // Taken from the new design
    xl: "1.714rem",
    // Taken from the new design
    xxl: "3.286rem",
    half: "50%",
    full: "100%",
  },
  size: {
    xs: "0.286rem",
    s: "0.572rem",
    m: "1.143rem",
    l: "1.714rem",
    xl: "2.286rem",
    xxl: "2.857rem",
  },
  shadow: {
    s1: "0px 4px 10px 2px rgba(58,89,134,0.15)",
  },
};

export const wscThemeYellow: wscType = {
  ...wscTheme,
  palette: {
    ...wscTheme.palette,
    primary: {
      100: "#F1FF6C",
      300: "#E5FF00",
      500: "#B9D300",
      700: "#3F3F2B",
      contrastText: "#333333",
    },
  },
};

export const getTheme = (isPrimaryYellow?: boolean) =>
  createTheme({
    components: {
      MuiButtonBase: {
        defaultProps: {
          disableRipple: true,
        },
      },
      MuiCheckbox: {
        defaultProps: {
          disableRipple: true,
          disableFocusRipple: true,
          disableTouchRipple: true,
        },
      },
      MuiCssBaseline: {
        styleOverrides: {
          body: {
            "&::-webkit-scrollbar, & *::-webkit-scrollbar": {
              backgroundColor: "transparent",
              width: "0.571rem",
            },
            "&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb": {
              borderRadius: wscTheme.radius.l,
              backgroundColor: wscTheme.palette.neutral[500],
              minHeight: "2rem",
            },
          },
        },
      },
    },

    typography: {
      fontFamily: `"Inter","Helvetica","Arial",sans-serif`,
    },
    wsc: isPrimaryYellow ? wscThemeYellow : wscTheme,
  });
